"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact");

var hooks_1 = require("preact/hooks");

var helpers_1 = require("../helpers");

function Message(_ref) {
  var message = _ref.message,
      nickname = _ref.nickname,
      head = _ref.head,
      type = _ref.type;
  // 알림 게시글 등록 타입
  var boardNotiType = ['F02', 'F12', 'B02'];
  var notiType = (0, hooks_1.useMemo)(function () {
    if (boardNotiType.includes(type)) {
      return true;
    }

    return false;
  }, [type]);
  var newMessage = (0, hooks_1.useMemo)(function () {
    var tmp = (message || "").replace("<".concat(nickname, ">"), "<span class=\"nickname\">".concat(nickname, "</span>"));

    if (head) {
      tmp += ": ";
      tmp += notiType ? (0, helpers_1.htmlEntities)(head) : head;
    }

    return tmp;
  }, [message, nickname, head]);
  return (0, preact_1.h)("span", {
    className: "txt",
    dangerouslySetInnerHTML: {
      __html: newMessage
    }
  });
}

exports.default = Message;